import React from 'react';
import MediaDisplay from '@/components/media/MediaDisplay';
import { useLanguage } from '@/i18n/LanguageProvider';

export default function HeroMedia({ slide, viewing, onView }) {
  const { t } = useLanguage();
  const type = slide.media_type || 'image';
  const url = type === 'video' ? slide.video_url : slide.image;
  return <>
    <MediaDisplay type={type} url={url} meta={slide.image_meta} autoplay={type === 'video'} controls={viewing} muted={!viewing} loading="eager" fetchPriority="high" className="h-full w-full object-cover" />
    {type === 'video' && !viewing && <button type="button" onClick={onView} className="absolute inset-0 z-10" aria-label={`${t('Visualizza')} ${slide.image_meta?.title || 'video'}`} />}
  </>;
}